import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'
import { ONE_MINUTE } from '../../constants/timing'
import { LinkableItems, LinkingItem } from '../../../components/Linking/Linking.types'
import { useSelector } from 'react-redux'

export const useGetLinkableItemsQuery = (type: LinkingItem['type']) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const getEndpointByType = () => {
        switch (type) {
            case 'activity':
                return endpoints.getActivityLinkableItems
            case 'evidence':
                return endpoints.getEvidenceLinkableItems
            case 'valueMessage':
                return endpoints.getValueMessageLinkableItems
            case 'strategicImperative':
                return endpoints.getStrategicImperativeLinkableItems
            case 'tppCell':
                return endpoints.getTppCellLinkableItems
            default:
                return null
        }
    }

    const getLinkableItems = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const endpoint = getEndpointByType()
            if (!endpoint) return null

            const response = await callAPI(endpoint.url + strategyId, endpoint.method, token)

            return response.data as LinkableItems
        } catch (e) {
            console.log(e)
        }
    }

    return useQuery<LinkableItems>(['linkableItems', strategyId, type], getLinkableItems, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!strategyId && !!type,

        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,

        cacheTime: ONE_MINUTE,
        staleTime: ONE_MINUTE,
    })
}
